/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAdministrator } from '../models/api-response-administrator';
import { ApiResponseListAdministrator } from '../models/api-response-list-administrator';
import { ApiResponsePagedResultAdministrator } from '../models/api-response-paged-result-administrator';
import { createAdministrator } from '../fn/administrator-api/create-administrator';
import { CreateAdministrator$Params } from '../fn/administrator-api/create-administrator';
import { deleteAdministrator } from '../fn/administrator-api/delete-administrator';
import { DeleteAdministrator$Params } from '../fn/administrator-api/delete-administrator';
import { getAdministratorByRef } from '../fn/administrator-api/get-administrator-by-ref';
import { GetAdministratorByRef$Params } from '../fn/administrator-api/get-administrator-by-ref';
import { listAdministrator } from '../fn/administrator-api/list-administrator';
import { ListAdministrator$Params } from '../fn/administrator-api/list-administrator';
import { patchStatusAdministrator } from '../fn/administrator-api/patch-status-administrator';
import { PatchStatusAdministrator$Params } from '../fn/administrator-api/patch-status-administrator';
import { searchAdministrator } from '../fn/administrator-api/search-administrator';
import { SearchAdministrator$Params } from '../fn/administrator-api/search-administrator';
import { updateAdministrator } from '../fn/administrator-api/update-administrator';
import { UpdateAdministrator$Params } from '../fn/administrator-api/update-administrator';

@Injectable({ providedIn: 'root' })
export class AdministratorApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAdministratorByRef()` */
  static readonly GetAdministratorByRefPath = '/v1/api/admin-ui/administrator/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministratorByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministratorByRef$Response(params: GetAdministratorByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAdministrator>> {
    return getAdministratorByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministratorByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministratorByRef(params: GetAdministratorByRef$Params, context?: HttpContext): Observable<ApiResponseAdministrator> {
    return this.getAdministratorByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAdministrator>): ApiResponseAdministrator => r.body)
    );
  }

  /** Path part for operation `updateAdministrator()` */
  static readonly UpdateAdministratorPath = '/v1/api/admin-ui/administrator/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAdministrator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdministrator$Response(params: UpdateAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAdministrator>> {
    return updateAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAdministrator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAdministrator(params: UpdateAdministrator$Params, context?: HttpContext): Observable<ApiResponseAdministrator> {
    return this.updateAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAdministrator>): ApiResponseAdministrator => r.body)
    );
  }

  /** Path part for operation `deleteAdministrator()` */
  static readonly DeleteAdministratorPath = '/v1/api/admin-ui/administrator/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAdministrator()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrator$Response(params: DeleteAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAdministrator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrator(params: DeleteAdministrator$Params, context?: HttpContext): Observable<void> {
    return this.deleteAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAdministrator()` */
  static readonly CreateAdministratorPath = '/v1/api/admin-ui/administrator';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAdministrator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdministrator$Response(params: CreateAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAdministrator>> {
    return createAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAdministrator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAdministrator(params: CreateAdministrator$Params, context?: HttpContext): Observable<ApiResponseAdministrator> {
    return this.createAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAdministrator>): ApiResponseAdministrator => r.body)
    );
  }

  /** Path part for operation `searchAdministrator()` */
  static readonly SearchAdministratorPath = '/v1/api/admin-ui/administrator/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAdministrator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAdministrator$Response(params: SearchAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAdministrator>> {
    return searchAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAdministrator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAdministrator(params: SearchAdministrator$Params, context?: HttpContext): Observable<ApiResponsePagedResultAdministrator> {
    return this.searchAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAdministrator>): ApiResponsePagedResultAdministrator => r.body)
    );
  }

  /** Path part for operation `listAdministrator()` */
  static readonly ListAdministratorPath = '/v1/api/admin-ui/administrator/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAdministrator()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdministrator$Response(params: ListAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAdministrator>> {
    return listAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAdministrator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAdministrator(params: ListAdministrator$Params, context?: HttpContext): Observable<ApiResponseListAdministrator> {
    return this.listAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAdministrator>): ApiResponseListAdministrator => r.body)
    );
  }

  /** Path part for operation `patchStatusAdministrator()` */
  static readonly PatchStatusAdministratorPath = '/v1/api/admin-ui/administrator/status/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchStatusAdministrator()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchStatusAdministrator$Response(params: PatchStatusAdministrator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchStatusAdministrator(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchStatusAdministrator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchStatusAdministrator(params: PatchStatusAdministrator$Params, context?: HttpContext): Observable<void> {
    return this.patchStatusAdministrator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
